(function () {
	'use strict';

	angular.module('app.shell').directive('edFooterSimpler', [edFooterSimpler]);

	function edFooterSimpler() {
		var directive = {
			// controller: ['$scope', '$rootScope', controller],
			templateUrl: '/app/content/footer/edFooterSimpler.html',
			// restrict: 'EA',
			// scope: {},
		};
		return directive;

		// function controller($scope, $rootScope) {
		// 	$scope.lang = $rootScope.lang;


		// }
	}
})();
